import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TeamPage from "./pages/TeamPage";
import MemberPage from "./pages/MemberPage";
import ServicePage from "./pages/ServicePage";
import ProductPage from "./pages/ProductPage";
import PublicationPage from "./pages/PublicationPage";
import PublicationDetail from "./pages/PublicationDetailPage";
import Events from "./pages/EventsPage";
import YourDataPage from "./pages/YourDataPage";
import GalleryPage from "./pages/GalleryPage";
import YearPage from "./pages/YearPage";
import CareerPage from "./pages/CareerPage";
import ContactUsPage from "./pages/ContactUsPage";
import UserLogin from "./pages/UserLogin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AboutPage from "./pages/AboutPage";
import InsolvencyCasesPage from "./pages/InsolvencyCasesPage";
import GangaPage from "./pages/GangaPage";
import SakthiGaneshPage from "./pages/SakthiGaneshPage";
import NewsPage from "./pages/NewsPage";
import KnowledgeBankPage from "./pages/KnowledgeBankPage";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/cases" element={<InsolvencyCasesPage />} />
        <Route path="/publications" element={<PublicationPage />} />
        <Route path="/publication-detail" element={<PublicationDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/member/:id" element={<MemberPage />} />
        <Route path="/data" element={<YourDataPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/year" element={<YearPage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/ganga" element={<GangaPage />} />
        <Route path="/sakthiganesh" element={<SakthiGaneshPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/knowledge" element={<KnowledgeBankPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
